// extracted by mini-css-extract-plugin
module.exports = {"infoHeader":"InfoPicker_infoHeader__2_Nwf"};